export default __webpack_public_path__ + "static/media/fb2025.228cb6af.JPG";